




















import Vue, { PropType } from 'vue';

export type SNS_NAME = 'facebook' | 'instagram' | 'x_twitter' | 'pinterest' | 'youtube';

export type GSnsButtonColor = 'white' | 'black' | 'gray';

// interface IconImageMap {
//   [name: string]: {
//     [color: string]: string;
//   };
// }

export default Vue.extend({
  name: 'GSnsButton',
  props: {
    to: String as PropType<string>,
    color: {
      type: String as PropType<GSnsButtonColor>,
      default: 'black',
      required: false,
    },
    sns: {
      type: String as PropType<SNS_NAME>,
      required: true,
    },
    border: {
      type: Boolean as PropType<boolean>,
      default: true,
      required: false,
    },
    transparent: {
      type: Boolean as PropType<boolean>,
      default: false,
      required: false,
    },
  },
  computed: {
    url(): string {
      const { sns, to } = this.$props;
      switch (sns) {
        case 'x_twitter':
          return `https://x.com/${to}`;
        case 'facebook':
          return `https://www.facebook.com/${to}`;
        case 'instagram':
          return `https://www.instagram.com/${to}`;
        case 'pinterest':
          return `https://www.pinterest.jp/${to}`;
        case 'youtube':
          return `https://www.youtube.com/channel/${to}`;
        default:
          return '';
      }
    },
  },
});
